import { Platform } from "react-native";

const API_VERSION = "v3";
const platform = Platform.OS;

const Routes = {
  FORGOT_PASSWORD: API_VERSION + "/users/password",
  BRANDING_THEME: API_VERSION + "/branding_themes",
  CONFIG: "/webapp/config.json",
  DATA_REFRESH_INFO: API_VERSION + "/commons/data_refresh_info",
  ORG_SETTINGS: API_VERSION + "/commons/get_org_settings",
  THEME_TOKENS: `${
    process.env.EXPO_PUBLIC_ASSETS_HOST
  }token_file/Organization/${platform === "web" ? "Web" : "Mobile"}_${
    process.env.EXPO_PUBLIC_ORGANIZATION_ID
  }.json`,
  TRANSLATIONS: `${process.env.EXPO_PUBLIC_ASSETS_HOST}custom_text/Organization/version_0/${process.env.EXPO_PUBLIC_ORGANIZATION_ID}.json`,
  NAVIGATION_MENU: `${process.env.EXPO_PUBLIC_ASSETS_HOST}customization_without_product_type/json_navigation_menu/Organization/version_0/${process.env.EXPO_PUBLIC_ORGANIZATION_ID}.json`,
  PDP_API: `${process.env.EXPO_PUBLIC_ASSETS_HOST}customization/pdp/Organization/version_0/${process.env.EXPO_PUBLIC_ORGANIZATION_ID}.json`,
  UNIFIED_PAGES_API: `${
    process.env.EXPO_PUBLIC_ASSETS_HOST
  }customization_without_product_type/unified_page/Organization${
    process.env.EXPO_PUBLIC_ORGANIZATION_ID &&
    process.env.EXPO_PUBLIC_ORGANIZATION_ID !== "1"
      ? "/version_0"
      : ""
  }/${process.env.EXPO_PUBLIC_ORGANIZATION_ID}.json`,
  UNIFIED_PRODUCT_PAGES_API: `${
    process.env.EXPO_PUBLIC_ASSETS_HOST
  }customization/product_unified_page/Organization${
    process.env.EXPO_PUBLIC_ORGANIZATION_ID &&
    process.env.EXPO_PUBLIC_ORGANIZATION_ID !== "1"
      ? "/version_0"
      : ""
  }/${process.env.EXPO_PUBLIC_ORGANIZATION_ID}.json`,
  GLOBAL: `${process.env.EXPO_PUBLIC_ASSETS_HOST}customization_without_product_type/global/Organization/version_0/${process.env.EXPO_PUBLIC_ORGANIZATION_ID}.json`,
  SEARCH_FORM_API: `${process.env.EXPO_PUBLIC_ASSETS_HOST}customization/search_form/Organization/version_0/${process.env.EXPO_PUBLIC_ORGANIZATION_ID}.json`,
  SEARCH_RESULT_API: `${process.env.EXPO_PUBLIC_ASSETS_HOST}customization/search_result/Organization/version_0/${process.env.EXPO_PUBLIC_ORGANIZATION_ID}.json`,

  SIGN_IN: API_VERSION + "/users/sign_in",
  CHECK_USER_ACTIVATION: API_VERSION + "/commons/check_activation_confirmation",
  EMAIL_VERIFICATION: API_VERSION + "/users/send_confirmation_instructions",
  ONBOARDING_DATA: API_VERSION + "/onboarding_screen",
  DELETE_ACCOUNT: (id: number) => `${API_VERSION}/users/${id}/deleted_user`,
  USER_TERMS_AND_CONDITIONS: API_VERSION + "/users/terms_of_service",
  ACCEPT_TERMS_AND_CONDITIONS: (id: number) => API_VERSION + `/users/${id}`,
  TOKEN_VERIFICATION: "v1/users/password/edit",
  UPDATE_PASSWORD: "v1/users/password",
  REQUEST_HISTORY: API_VERSION + "/stock_item_requests",
  JBT_CONNECT: API_VERSION + "/jbt/link_account",
  ADD_NEW_COLLECTION: API_VERSION + "/collections",
  GET_UNIFIED_COLLECTIONS: API_VERSION + "/collections",
  GET_TOTAL_FAVORITES: API_VERSION + "/favorites/total",
  RENAME_COLLECTION: (id: number) => API_VERSION + `/collections/${id}`,
  DELETE_COLLECTION: (id: number) => API_VERSION + `/collections/${id}`,
  GET_USER_DETAILS: (id: number) => API_VERSION + `/users/${id}`,
  UPDATE_USER: (id: number) => API_VERSION + `/users/${id}`,
  SAVED_SEARCH_RESULT: API_VERSION + "/saved_searches",
  SAVED_SEARCH_EDIT_TITLE: (id: number) =>
    API_VERSION + "/saved_searches" + `/${id}`,
  SAVED_SEARCH_DELETE: (id: number) =>
    API_VERSION + "/saved_searches" + `/${id}`,
  SEARCH_RESULT_DIAMOND: API_VERSION + "/vdb/search_diamonds",
  DELETE_ACCOUNT_DISCLAIMER: API_VERSION + "/users/account_delete_disclaimer",
  SEARCH_RESULT_JEWELRY: API_VERSION + "/jewelries/search",
  SEARCH_RESULT_GEMSTONE: API_VERSION + "/gemstones/search",
  SEARCH_GROUPS: (product_type: number) =>
    API_VERSION + `/users/company_groups?product_type=${product_type}`,
  ITEM_MEDIA: API_VERSION + "/vdb/media",
  SHARE_VIA_LINK: API_VERSION + "/shared_links",
  SHARE: API_VERSION + "/notifications/send_email",
  CONTACT_US: API_VERSION + "/users/contact_us",
  PUBLIC_CONTACT_US: API_VERSION + "/commons/contact_us",
  GET_UNREAD_REQUEST: API_VERSION + "/stock_item_requests/unread_requests",
  UPDATE_READ_REQUEST: (id: number) =>
    API_VERSION + `/stock_item_requests/${id}/update_read`,
  GET_DIAMOND_BY_ID: API_VERSION + "/vdb/get_diamonds_by_id",
  GET_GEMSTONE_BY_ID: API_VERSION + "/gemstones/search",
  GET_JEWELRY_BY_ID: API_VERSION + "/jewelries/search",

  GET_SIMILAR_DIAMOND: (product_type: number) =>
    API_VERSION + `/diamonds/${product_type}/similar`,

  NAV_MENU: `${process.env.EXPO_PUBLIC_ASSETS_HOST}Customization_without_product_type/json_navigation_menu/Organization/${process.env.EXPO_PUBLIC_ORGANIZATION_ID}.json`,
  GET_FAVORITES: API_VERSION + "/favorites",
  GET_COLLECTIONS_DETAIL_LIST: (id: number) =>
    API_VERSION + `/collections/${id}`,
  CAN_REQUEST_AGAIN: (stockItemId: number, requestType: string) =>
    `${API_VERSION}/stock_item_requests/can_request_again?stock_item_request[stock_item_id]=${stockItemId}&stock_item_request[request_type]=${requestType}`,
  DYNAMIC_REGISTRATION: API_VERSION + "/vdb_graphql",
  IS_USERNAME_AVAILABLE: API_VERSION + "/users/username_available",
  STOCK_ITEM_REQUEST: API_VERSION + "/stock_item_requests",
  STOCK_ITEM_REQUEST_DETAIL: (id: string) =>
    API_VERSION + "/stock_item_requests/" + id,
  BULK_REQUEST_UPDATE: API_VERSION + "/update_bulk_request/",
  STOCK_ITEM_REQUEST_DETAIL_MESSAGES: (id: string) =>
    API_VERSION + "/stock_item_requests/" + id + "/stock_item_request_messages",
  REPORT_AN_ISSUE: API_VERSION + "/report_issues",
  ISSUE_TYPES: API_VERSION + "/report_issues/issue_types",
  SEARCH_CERTS: `${API_VERSION}/commons/matching_certs`,
  ADD_DIAMOND_FAVORITES: API_VERSION + "/favorites",
  DELETE_DIAMOND_FAVORITES: (id: number) =>
    API_VERSION + `/favorites/${id}/delete?type=mix`,
  DELETE_ITEM_FAVORITES: (id: number) =>
    API_VERSION + `/favorites/${id}/delete?type=mix`,
  ADD_GEMSTONE_FAVORITES: API_VERSION + "/gemstone_favorites",

  ADD_JEWELRY_FAVORITES: API_VERSION + "/jewelry_favorites",

  ADD_ITEMS_TO_COLLECTIONS: API_VERSION + "/collections/add_items",
  BULK_ACTIONS: API_VERSION + "/bulk_actions",
  REMOVE_ITEM_FROM_COLLECTION: API_VERSION + "/collections/remove_items",
  REMOVE_ITEM_FROM_FAVORITES: API_VERSION + "/favorites/remove_favorites",
  CUSTOM_LOGO: (company: number, priceMode: number) =>
    `${API_VERSION}/get_logo?company_name=${company}&price_mode=${priceMode}`,
  SIGN_OUT: API_VERSION + "/users/sign_out",
  GET_AD_BANNER: API_VERSION + "/commons/ad_banner",
  REQUEST_URL: `${process.env.EXPO_PUBLIC_ASSETS_HOST}customization_without_product_type/stock_item_request_summary/Organization/${process.env.EXPO_PUBLIC_ORGANIZATION_ID}.json`,
  ONE_SIGNAL_USER_INFO: (userId: number) =>
    API_VERSION + `/users/${userId}/device_tokens`,
  ONE_SIGNAL_DELETE_USER_INFO: (userId: number, subscriberId: string) =>
    `/v3/users/${userId}/device_tokens/${subscriberId}`,
  GET_GIA_CERTIFICATE: (id: number) =>
    API_VERSION + "/commons/" + id + "/get_gia_certificate",
  ADD_TO_BULK_REQUEST: API_VERSION + "/cart",
  GET_CART_ITEMS: API_VERSION + "/cart",
  OFFLINE_PAYMENT: API_VERSION + "/capture-store-transaction",
  PAYPAL_CAPTURE_TRANSACTION: API_VERSION + "/capture_transaction", // PayPal capture transaction endpoint
  ORDERS: API_VERSION + "/orders", // PayPal order endpoint (deprecated)
  ORDER_CHECKOUT: API_VERSION + "/orders/order_cart_checkout",
  ORDER_REQUESTS: (id: string) => API_VERSION + `/orders/${id}`,
  ORDER_ACTIONS: (id: string) => API_VERSION + `/orders/${id}/order_actions`,
  REMOVE_FROM_BULK_REQUEST: API_VERSION + "/cart/remove_cart_items",
  MARK_CART_SOLD: API_VERSION + "/cart/mark_sold",
  REMOVE_FROM_ORDER_CART: (id: string) => API_VERSION + `/cart/${id}`,
  UNIFIED_BULK_REQUEST: API_VERSION + "/unified_cart",
  BULK_CHECKOUT: API_VERSION + "/bulk_checkout",
  USER_CONFIRMATION: API_VERSION + "/users/confirmation",
  COMPANY_IMAGES: API_VERSION + "/commons/company_org_images",
  WEB_UPDATES_CHECK: process.env.EXPO_PUBLIC_WEB_UPDATES_CHECK_URL,
  UPDATE_USER_JBT: (id: number) => API_VERSION + `/users/${id}`,
  GET_REQUEST_CHILDREN: (id: number) =>
    API_VERSION + `/stock_item_requests/${id}/children`,
  GET_JEWELRY_VARIATION: (id: number) =>
    API_VERSION + `/jewelries/${id}/jewelry_variations`,
  GET_JEWELRY_COMPONENTS: (id: number) =>
    API_VERSION + `/jewelries/${id}/jewelry_components`,
  GET_ADD_TO_JEWELRY_OPTIONS: API_VERSION + `/jewelries/add_to_jewelry_options`,
  USER_TOKENS: (id: string | number) =>
    API_VERSION + `/users/${id}/user_tokens`,
  USER_TOKENS_DELETE_TOKEN: (id: number, token: string) =>
    API_VERSION + `/users/${id}/user_tokens/${token}`,
  USER_TOKENS_DELETE_ALL: (id: number) =>
    API_VERSION + `/users/${id}/user_tokens/delete_all`,
  MFA_OTP_SEND_OTP: API_VERSION + `/mfa_otp/send_otp`,
  MFA_OTP_VALIDATE_OTP: API_VERSION + `/mfa_otp/validate_otp`,
  GET_KNOWI_DASHBOARD: API_VERSION + `/knowi`,
  GET_SHIPPING_METHODS: API_VERSION + `/shipping_methods`,
  USER_LIST: API_VERSION + `/users/fetch_all_users`,
  INVITE_USER: API_VERSION + `/users/invite_users_via_app`,
  CREATE_CONTRACT: `/api/billing/contracts`,
  VALIDATE_COUPON: API_VERSION + `/coupons/validate`,
  MIN_MAX_OPTIONS: (id: number) =>
    API_VERSION + `/jewelries/${id}/get_mix_max_options`,
  GET_CURRENT_APP_VERSION: API_VERSION + "/users/current_app_version",
  SEARCH_BARCODE: API_VERSION + "/commons/barcode_redirect",
  UPDATE_CONTRACT: `/api/billing/contracts/update_contract`,
  GET_BRANDS_LIST: API_VERSION + `/jewelries/all_jewelry_brand_with_id`,
  GET_ALL_BRANDS: API_VERSION + `/jewelries/all_jewelry_brands`,
  EXPORTS: API_VERSION + "/exports",
  EXPORTS_BY_ID: (id: number) => API_VERSION + "/exports" + `/${id}`,
  SHOPIFY_CREATE_PRODUCT: API_VERSION + "/shopify/create",
  CHECK_ITEM_AVAILABILITY: API_VERSION + `/cart/check_item_availability`,
  GET_MATCHING_BAND_DATA: (productId: number | string) =>
    API_VERSION + `/jewelries/${productId}/matching_items`,
  CHECK_USER_EXISTS: API_VERSION + `/commons/user_exists`,
  COUNTRY_LIST: API_VERSION + "/commons/country_list",
  STATES_LIST: API_VERSION + "/commons/states_list_based_on_country",
  CITIES_LIST: API_VERSION + "/commons/cities_based_on_country",
  BUSINESS_TYPE_OPTIONS: API_VERSION + "/users/business_type_options",
  REPORT_BAD_MEDIA: API_VERSION + "/commons/report_bad_media",
  DOWNLOAD_FILE: API_VERSION + "/commons/download_file",
  CHECK_STORE_AVAILABILITY: API_VERSION + "/check_stock_availablity",
  SHARED_LINKS: (id: string) => API_VERSION + "/shared_links/" + id,
  CANCEL_UPCOMING_RENEWAL: (subscription_id: string) =>
    `api/billing/contracts/${subscription_id}/cancel_upcoming_renewal`,
  UPDATE_RENEWAL_CONTRACT: (subscription_id: string) =>
    `/api/billing/contracts/${subscription_id}/manage_upcoming_renewal`,
  KEEP_MY_RENEWAL: "/api/billing/contracts/create_paid_renewal",

  // Registration Flow APIs
  UPDATE_REGISTRATION: (userId: number) =>
    API_VERSION + `/users/${userId}/update_registration`,
  GOOGLE_DRIVE_UPLOAD: API_VERSION + "/google_drive/documents/upload",
  GOOGLE_DRIVE_DELETE: API_VERSION + "/google_drive/documents",
  USER_ATTRIBUTES: (userId: number) =>
    API_VERSION + `/users/${userId}/user_attributes`,
  COUNTRY_FROM_IP: API_VERSION + "/users/get_country_from_ip",
};

export default Routes;
